import { Component, OnInit } from '@angular/core';
import { CriteriaComponent } from '../../../pages/criteria/criteria.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-criteria-form',
  templateUrl: './criteria-form.component.html',
  styleUrls: ['./criteria-form.component.scss']
})
export class CriteriaFormComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }

  openCriteriaDialog(){
    const dialogRef = this.dialog.open(CriteriaComponent);



    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog closed: ${result}`);
    });
  }

}
